exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-upload[data-v-a2dfba10] {\n  position: initial !important;\n}\n.file-upload[data-v-a2dfba10]:before {\n  top: calc(50% - 45px) !important;\n  right: 0 !important;\n}\n", ""]);

// exports
